import React from 'react';
import { motion } from 'framer-motion';
interface GlassCardProps {
  children: React.ReactNode;
  className?: string;
  delay?: number;
}
export function GlassCard({
  children,
  className = '',
  delay = 0
}: GlassCardProps) {
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    duration: 0.5,
    delay,
    ease: [0.23, 1, 0.32, 1]
  }} className={`glass-panel rounded-2xl p-6 ${className}`} data-id="element-228">
      {children}
    </motion.div>;
}